<template>
    <v-dialog v-model="dialog" persistent transition="scale-transition" max-width="600px">
        <v-card class="elevation-1">
            <ValidationObserver ref="refFormAbono" v-slot="{ invalid, validated }">
                <v-form name="form" @submit.prevent="save" lazy-validation>
                    <v-toolbar dark color="primary">
                        <v-btn icon dark @click.native="handleModal">
                            <v-icon>fas fa-times-circle</v-icon>
                        </v-btn>
                        <v-toolbar-title>Nuevo abono directo</v-toolbar-title>
                        <v-spacer></v-spacer>
                        <v-toolbar-items>
                            <v-btn class="primary" type="submit" :disabled="invalid || !validated" :loading="loading">
                                <v-icon class="ma-2" dense large left>fas fa-save</v-icon>Guardar abono
                            </v-btn>
                        </v-toolbar-items>
                    </v-toolbar>
                    <v-card-text>
                        <v-row>
                            <v-col cols="12">
                                <p><strong>Concepto:</strong> {{ deduccionSelected.concepto }}</p>
                                <p><strong>Saldo pendiente:</strong> {{ formatNumberToMoney(deduccionSelected.saldoValor) }}</p>
                            </v-col>
                            <v-col cols="12" sm="6">
                                <ValidationProvider rules="required|numeric|min_value:1" v-slot="{ errors, valid}">
                                    <v-text-field type="number" label="Monto a abonar*" prepend-icon="fas fa-dollar-sign"
                                    required v-model.number="abono.monto" min="1"
                                    :error-messages="errors" :success="valid">
                                    </v-text-field>
                                </ValidationProvider>
                            </v-col>
                            <v-col cols="12" sm="6">
                                <ValidationProvider rules="required" v-slot="{ errors, valid}">
                                    <v-autocomplete :items="cashRegisters" item-text="folio" item-value="id"
                                    v-model="abono.cashRegisterId" label="Caja*" required
                                    prepend-icon="fas fa-cash-register"
                                    hint="Caja donde se registrara el abono" persistent-hint
                                    :error-messages="errors" :success="valid">
                                    </v-autocomplete>
                                </ValidationProvider>
                            </v-col>
                        </v-row>
                        <small>* Indica son campos requeridos</small>
                    </v-card-text>
                </v-form>
            </ValidationObserver>
        </v-card>
    </v-dialog>
</template>

<script>
import AbonoDeduccionDataService from '@/service/deduccion/AbonoDeduccionDataService';
import CashRegisterDataService from '@/service/cashRegister/CashRegisterDataService';
import { getFormatCurrency } from '@/utils/CurrencyUtil';

export default {
    name: "NuevoAbonoDirecto",
    props: {
        dialog: { type: Boolean, default: false },
        handleModal: { type: Function },
        initialize: { type: Function },
        deduccionSelected: { type: Object, default: () => ({}) }
    },
    created() {
        this.getCashRegisters();
    },
    data() {
        return {
            loading: false,
            cashRegisters: [],
            abono: {
                monto: "",
                cashRegisterId: null
            }
        }
    },
    methods: {
        async getCashRegisters() {
            this.cashRegisters = await CashRegisterDataService.findCashRegisterOpened().then(resp => resp.data) || [];
        },
        formatNumberToMoney(number) {
            return getFormatCurrency(parseFloat(number) || 0, "$");
        },
        save() {
            this.$refs.refFormAbono.validate().then(isValid => {
                if (!isValid) return;
                this.loading = true;
                const request = {
                    monto: String(this.abono.monto),
                    idDeduccion: this.deduccionSelected.id,
                    cashRegisterId: this.abono.cashRegisterId
                };
                AbonoDeduccionDataService.createDirect(request).then(() => {
                    this.$refs.refFormAbono.reset();
                    this.handleModal();
                    this.initialize();
                    this.$swal.fire({ position: 'top-end', title: 'Abono registrado', text: 'El abono se registro correctamente', icon: 'success', showConfirmButton: false, timer: 2000 });
                }).catch(err => {
                    this.$swal.fire({ position: 'top-end', title: 'Error al registrar el abono', text: err.response?.data, icon: 'error', showConfirmButton: false, timer: 3000 });
                }).finally(() => this.loading = false);
            });
        }
    }
}
</script>
